<template>
    <div>
        <network-icon :network="network.slug" v-if="network" />
        <span class="text-bold">{{ deliverable.type }}</span>
        <span class="text-light text-14">({{ total_count }} total, {{ deliverable.quantity }} {{ schedule }})</span>

        <div class="mt-5 mb-15">
            <div class="mb-5" v-html="$sanitize(deliverable.requirements)" v-if="show_requirements"></div>
            <a class="text-14" @click.prevent="show_requirements = !show_requirements">
                {{ show_requirements ? 'Hide' : 'Show' }} Requirements
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'DeliverablePreview',

        /**
         * The component properties
         *
         * @type {object}
         */
        props: {
            /**
             * The deal
             */
            deal: {
                type: Object,
                required: true
            },

            /**
             * The deliverable
             */
            deliverable: {
                type: Object,
                required: true
            }
        },

        /**
         * The component data
         *
         * @returns {object}
         */
        data() {
            return {
                /**
                 * Whether to show the requirements
                 *
                 * @type {boolean}
                 */
                show_requirements: false
            };
        },

        /**
         * The component's computed properties
         *
         * @type {object}
         */
        computed: {
            /**
             * The network
             *
             * @returns {object}
             */
            network() {
                return this.deliverable.network;
            },

            /**
             * The first proposal indexes
             *
             * @returns {array}
             */
            first_proposal_indexes() {
                return this.deliverable.proposal_indexes.slice(0, this.deliverable.proposal_indexes.length - 1);
            },

            /**
             * The last proposal index
             *
             * @returns {number}
             */
            last_proposal_index() {
                return this.deliverable.proposal_indexes[this.deliverable.proposal_indexes.length - 1];
            },

            /**
             * The total count for the deliverable
             *
             * @returns {number}
             */
            total_count() {
                if (this.deliverable.proposal_interval === 'all') {
                    return this.deal.duration_length * this.deliverable.quantity;
                }

                if (this.deliverable.proposal_interval === 'alternate') {
                    let rem = Math.round((this.deal.duration_length - this.deliverable.starting_proposal_index) / 2);
                    return rem * this.deliverable.quantity;
                }

                if (this.deliverable.proposal_interval === 'specific') {
                    return this.deliverable.proposal_indexes.length * this.deliverable.quantity;
                }
            },

            /**
             * The deliverable schedule
             *
             * @returns {string}
             */
            schedule() {
                if (this.deliverable.proposal_interval === 'all') {
                    return `every ${this.deal.duration_interval}`;
                }

                if (this.deliverable.proposal_interval === 'alternate') {
                    return `every other ${this.deal.duration_interval} starting in ${this.deal.duration_interval} ${this.deliverable.starting_proposal_index}`;
                }

                if (this.deliverable.proposal_interval === 'specific') {
                    if (this.deliverable.proposal_indexes.length === 1) {
                        return `in ${this.deal.duration_interval} ${this.last_proposal_index}`;
                    }

                    return `each ${this.deal.duration_interval} in ${
                        this.deal.duration_interval
                    }s ${this.first_proposal_indexes.join(', ')} and ${this.last_proposal_index}`;
                }
            }
        }
    };
</script>
